import { useAppSelector } from '@core/hooks/redux-hooks';
import { getOpmForecastProbabilityWeightedValue } from '@app/shared/helpers/get-weighted-values';
import { OpmForecastDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import {
  getInitialTotalEquityByInstrumentTypeAndOwnership,
  selectInstrumentsWithInitialValues,
} from '@app/core/store/capital-structure-slice-selectors';

export const useOpmTotalEquityGeneralMetrics = (forecasts: OpmForecastDto[]) => {
  const instruments = useAppSelector(selectInstrumentsWithInitialValues);

  const getTotalEquityProceedsWeightedValue = getOpmForecastProbabilityWeightedValue({
    forecasts,
    getValue: ({ forecast }) => forecast.totalEquityProceeds,
  });

  const getExitSlnDebtProceedsWeightedValue = getOpmForecastProbabilityWeightedValue({
    forecasts,
    getValue: ({ forecast }) => forecast.totalShareholderDebtProceeds,
  });

  const getExitOrdinaryProceedsWeightedValue = getOpmForecastProbabilityWeightedValue({
    forecasts,
    getValue: ({ forecast }) => forecast.totalOrdinaryEquityProceeds,
  });

  const getExitSweetOrdinaryProceedsWeightedValue = getOpmForecastProbabilityWeightedValue({
    forecasts,
    getValue: ({ forecast }) => forecast.totalSweetEquityProceeds,
  });

  const entryTotalEquityValue = getInitialTotalEquityByInstrumentTypeAndOwnership(instruments);

  const equityProceedsWeightedValue = getTotalEquityProceedsWeightedValue;

  const exitSlnDebtProceeds = getExitSlnDebtProceedsWeightedValue;

  const exitOrdinaryEquityProceeds = getExitOrdinaryProceedsWeightedValue;

  const sweetEquityProceedsWeightedValue = getExitSweetOrdinaryProceedsWeightedValue;

  const sweetEquityPercentageOfOrdinaryEquityProceeds =
    (sweetEquityProceedsWeightedValue / exitOrdinaryEquityProceeds) * 100;

  return {
    entryTotalEquityValue,
    equityProceedsWeightedValue,
    exitSlnDebtProceeds,
    exitOrdinaryEquityProceeds,
    sweetEquityPercentageOfOrdinaryEquityProceeds,
  };
};
